import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type ListUndeliveredParams,
  type UndeliveredPage,
} from "../../../domain/entities/undelivered";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listUndelivered = createAsyncThunk<
  UndeliveredPage,
  ListUndeliveredParams,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST, async (params, { extra }) => {
  return await extra.undeliveredRepo.list(params);
});
